import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { IncomeExpensesServices } from '../../../income-expenses/services';

/**
 * Generated class for the DishTutorialSlidePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-inexp-tutorial-slide',
  templateUrl: 'inexp-tutorial-slide.html',
})
export class InexpTutorialSlidePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public incomeExpensesServices: IncomeExpensesServices) {
  }

  ionViewDidLoad() {
  }

  ionViewDidLeave() {
    this.closeLeave();
  }

  close() {
    this.globals.restaurant.tutorial_inexp = true;
    this.incomeExpensesServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_inexp': this.globals.restaurant.tutorial_inexp,
    }).then(() => {
      this.navCtrl.pop();
    });

  }

  closeLeave() {
    this.globals.restaurant.tutorial_inexp = true;
    this.incomeExpensesServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_inexp': this.globals.restaurant.tutorial_inexp,
    }).then(() => {
    });
  }



}



// WEBPACK FOOTER //
// ./src/pages/help/tutorial-slider/inexp-tutorial-slide/inexp-tutorial-slide.ts